import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import Header from "../Components/Header.js"
import { Send, Loader, ArrowLeft } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'

export default function ContactForm ({ subject = "Escursione" }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [accepted, setAccepted] = useState(
    localStorage.getItem('policyAccepted') === 'true'
  )

  const handleAcceptance = (e) => {
    const isChecked = e.target.checked
    setAccepted(isChecked)
    localStorage.setItem('policyAccepted', isChecked)
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const defaultSubject = location.state?.subject || "Informazioni Generali";
  // 1. Gestione dello stato dell'oggetto (sostituisce v-model)
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    messaggio: ''
  })

  const [isSending, setIsSending] = useState(false)
  const [status, setStatus] = useState({ message: '', class: '' })

  // Gestore universale per gli input
  const  handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  };

  const handleSubmit = async (e) => {
    e.preventDefault() // Sostituisce @submit.prevent
    setIsSending(true)
    
    try {
      const payload = { ...formData, subject: defaultSubject };
      await axios.post('/api/contact', payload)
      
      setStatus({ 
        message: "Messaggio inviato con successo!", 
        class: "success" 
      });      

      setFormData({
        nome: '',
        email: '',
        telefono: '',
        messaggio: ''
      });
    } 
    catch (error) {
      setStatus({ 
        message: "Errore durante l'invio. Riprova più tardi.", 
        class: "error" 
      });
      console.error("Dettagli errore:", error)
    } 
    finally {
      setIsSending(false)
      setTimeout(() => {
        setStatus({ message: '', class: '' });
      }, 2000)      
    }
    
    console.log("Dati inviati:", formData)
  }

  return (
    <>
      <Header />
      <div className="contact-container"> {/* class diventa className */}
      <h1 className='pt-5'>Scrivici per l'escursione <span style={{ color: '#0356af' }}>{defaultSubject}</span></h1> 
      <form onSubmit={handleSubmit} className="contact-form">
        
        <div className="form-group">
          <label>Nome</label>
          <input 
            name="nome"
            value={formData.nome} 
            onChange={handleChange} 
            type="text" 
            placeholder="Il tuo nome" 
            required 
          />
        </div>

        <div className="form-group">
          <label>E-mail</label>
          <input 
            name="email"
            value={formData.email} 
            onChange={handleChange} 
            type="email" 
            placeholder="latua@email.com" 
            required 
          />
        </div>

        <div className="form-group">
          <label>Telefono (Opzionale)</label>
          <input 
            name="telefono"
            value={formData.telefono} 
            onChange={handleChange} 
            type="tel" 
            placeholder="+39 123 4567890" 
          />
        </div>

        <div className="form-group">
          <label>Messaggio</label>
          <textarea 
            name="messaggio"
            value={formData.messaggio} 
            onChange={handleChange} 
            rows="5" 
            placeholder="Scrivici della tua escursione o richiedi altre informazioni!" 
            required
          />
        </div>
        <div className="policy-check-container">
          <input 
            type="checkbox" 
            id="policy" 
            checked={accepted} 
            onChange={handleAcceptance}
            required 
          />
          <label htmlFor="policy">
            Ho letto ed accetto la <Link to="/policy">Privacy Policy</Link>
          </label>
        </div>
        {/* Rendering condizionale: appare solo se status.message non è una stringa vuota */}
        {status.message && (
          <p className={`status-msg ${status.class}`}>
            {status.message}
          </p>
        )}        
        {/* Assegnazione condizionale del testo del bottone */}
        <button type="submit" className="contact-button-submit" disabled={isSending}>
          {isSending ? (
            <>
              <Loader className="spinner" size={18} />
              Invio in corso...
            </>
          ) : (
            <>
              Invia Messaggio
              <Send size={18} />
            </>
          )}
        </button>
        <button
          type="submit"
          onClick={() => navigate(-1)} 
          className="contact-button-submit"
        >
          <ArrowLeft size={20} /> {/* Oppure un semplice <span>←</span> */}
          Indietro
        </button>        
      </form>
    </div>
    </>
  )
}
